import { useCallback, useMemo } from 'react'
import { PenLine } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchResponsePrep, LEGAL_KIND_OPTS, LEGAL_STR as S, type LegalRow } from './legalFlowApi'

/**
 * A19.10 — Javob tayyorlash (response prep, read-only). Hali yopilmagan
 * (pending) so'rovlar — javob qoralamasi tayyorlanadigan bosqich. GET /admin/legal
 * ustidan. Backend yo'q/xato → fail-soft.
 */
export function LegalResponsePrepScreen() {
  const columns = useMemo<AdminColumn<LegalRow>[]>(
    () => [
      { key: 'id', header: S.id, type: 'id', width: 70 },
      { key: 'created_at', header: S.created, type: 'date', width: 150 },
      { key: 'kind', header: S.kind, type: 'enum', width: 140, options: LEGAL_KIND_OPTS },
      { key: 'authority', header: S.authority, type: 'text', minWidth: 180 },
      { key: 'jurisdiction', header: S.jurisdiction, type: 'text', width: 150 },
      { key: 'details', header: S.reason, type: 'longtext', minWidth: 200 },
    ],
    [],
  )
  const fetcher = useCallback(fetchResponsePrep, [])
  return (
    <>
      <PageHeader title={S.responseTitle} screenId="A19.10" description={S.responseDesc} />
      <DataTable<LegalRow>
        screenId="A19.10"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <PenLine size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
